module.exports = __webpack_public_path__ + "static/media/swag-toolkit-2020.4868fc24.jpg";